enum LineItemFormTab {
  Basic = 'Basic',
  Geo = 'Geo',
  DealGroups = 'Deals Groups',
  Audience = 'Audience',
  Daypart = 'Daypart',
  Creatives = 'Creatives',
  Summary = 'Summary',
}

export default LineItemFormTab;
